










import Vue from 'vue'
import { mapGetters } from 'vuex'

const languageKeys = {
  en: {
    text: 'Inglés',
    value: 'en'
  },
  es: {
    text: 'Español',
    value: 'es'
  }
} as Record<string, {text: string; value: string; }>

export default Vue.extend({
  name: 'Language',
  computed: {
    languageItems () {
      return Object.entries(languageKeys).map(languageKey => {
        return {
          text: this.$t(`${languageKey[1].text}`),
          value: languageKey[1].value
        }
      })
    },
    language: {
      set (newLanguage : string) {
        this.$i18n.locale = newLanguage

        localStorage.setItem('TRUORA_LANGUAGE', newLanguage)

        this.$store.commit('language/setLanguage', newLanguage)
      },
      get () {
        return this.getLanguage
      }
    },
    ...mapGetters('language', ['getLanguage'])
  }
})
